import React from 'react';
import * as PropTypes from 'prop-types';
import Image from 'next/image';

const CMS_ContactUsCard = ({ content: { title, content, image } }) => {
    return (
        <section className='relative mt-12' aria-labelledby='contact-heading'>
            <div className='mx-auto max-w-7xl bg-[#fcfcfc] lg:bg-transparent lg:px-8'>
                <div className='lg:grid lg:grid-cols-12'>
                    <div className='relative z-10 lg:col-span-4 lg:col-start-1 lg:row-start-1 lg:bg-transparent lg:py-16'>
                        <div className='mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:max-w-none lg:p-0'>
                            <div className='aspect-w-10 aspect-h-6 relative sm:aspect-w-2 sm:aspect-h-1 lg:aspect-w-1'>
                                <Image
                                    layout='fill'
                                    objectFit='cover'
                                    objectPosition='center'
                                    sizes='400px'
                                    className='rounded-xl object-cover object-center'
                                    src={image}
                                    alt={title}
                                />
                            </div>
                        </div>
                    </div>

                    <div className='relative -mt-12 bg-[#f7f5f1] lg:col-span-10 lg:col-start-3 lg:row-start-1 lg:mt-0 lg:grid lg:grid-cols-10 lg:items-center lg:rounded-xl'>
                        <div className='relative mx-auto max-w-md space-y-6 py-12 px-4 sm:max-w-3xl sm:py-16 sm:px-6 lg:col-span-6 lg:col-start-4 lg:max-w-none lg:p-0'>
                            <h2
                                className='font-bold text-3xl tracking-tight text-ui-black'
                                id='contact-heading'
                            >
                                {title}
                            </h2>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: content.replace('class="rich-text"', ''),
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

CMS_ContactUsCard.defaultProps = {};

CMS_ContactUsCard.propTypes = {
    content: PropTypes.object.isRequired,
};

export default CMS_ContactUsCard;
